import { __extends } from "tslib";
import BaseError from './base-error';
var CustomError = {
    withDefaultMessage: function (name, defaultMessage) {
        return /** @class */ (function (_super) {
            __extends(CustomError, _super);
            function CustomError(message, cause) {
                var _this = _super.call(this, message || defaultMessage || '', cause) || this;
                _this.name = name;
                Object.setPrototypeOf(_this, _this.constructor.prototype);
                return _this;
            }
            return CustomError;
        }(BaseError));
    },
    withMessageCreator: function (name, creator) {
        return /** @class */ (function (_super) {
            __extends(CustomError, _super);
            function CustomError(payload, cause) {
                var _this = _super.call(this, creator(payload), cause) || this;
                _this.name = name;
                Object.setPrototypeOf(_this, _this.constructor.prototype);
                return _this;
            }
            return CustomError;
        }(BaseError));
    },
};
export default CustomError;
//# sourceMappingURL=custom-error.js.map